<template>
  <div>
    <div v-show="loading" class="float-right caption">
      校正中
      <v-progress-linear
        color="teal darken-1"
        indeterminate
        stream
      ></v-progress-linear>
    </div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-show="!loading && noTargetWordsMessages(uuid()).length"
          small
          color="red lighten-1"
          style="font-style: normal !important"
          class="float-right button"
          v-bind="attrs"
          v-on="on"
        >
          info
        </v-icon>
      </template>
      <ul class="text-center">
        <span class="font-weight-bold"
          >校正の結果、以下の内容が検知されました。</span
        >
        <li
          v-for="(result, index) in noTargetWordsMessages(uuid())"
          :key="index"
        >
          {{ result }}
        </li>
      </ul>
    </v-tooltip>

    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PreviewLayout',
  props: {
    item: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      noTargetWordsMessages: 'TextLintStore/noTargetWordsMessages'
    })
  },
  methods: {
    uuid () {
      return this.item.id || this.item.uuid
    }
  }
}
</script>

<style>
.tooltip {
  position: relative;
  cursor: pointer;
  background-color: #f37f77;
  margin: 0 1px;
}

.description-top {
  width: 150px;
  position: absolute;
  left: 50%;
  bottom: 80%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 10px;
  background-color: #000;
  font-size: 0.7em;
  color: #fff;
  text-align: center;
  visibility: hidden;
  opacity: 0;
  z-index: 1;
  transition: 0.1s all;
}

.description-top::before {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  border: 6px solid transparent;
  border-top: 8px solid #000;
  margin-left: -8px;
}

.tooltip:hover .description-top {
  bottom: 100%;
  visibility: visible;
  opacity: 1;
}
</style>
